export default "/profile/images/telegram.png?89e96663585cd602efa601b2503183ec";